import { useNavigate, useParams } from "react-router-dom";
import { COPY } from "../shared/copy";
import { PushSetup } from "../components/PushSetup";

// Notification + PWA onboarding. Explains why installing/enabling matters and
// adapts to the platform (see components/PushSetup). Not a permanent warning
// banner — it's a one-time step after joining, and it's always skippable.
export function Onboarding() {
  const { leagueId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="app">
      <div className="spacer" />
      <h1>{COPY.notifOnboarding.headline}</h1>
      <p className="muted">{COPY.notifOnboarding.body}</p>

      <PushSetup leagueId={leagueId!} />

      <button className="btn ghost" onClick={() => navigate(`/league/${leagueId}`)}>
        Continue
      </button>
      <p className="muted center">You can set this up later from the league home.</p>
      <div className="spacer" />
    </div>
  );
}
